// The SoftLife lockup from the brand pack (brand/softlife-brand-pack-v1/01-logo),
// used as is: the dark version on night, never under 140 px wide, aspect ratio kept.
// The console's name ("staff") is set next to it in Bricolage, never inside it.
import lockupDark from "../../../../brand/softlife-brand-pack-v1/01-logo/lockups/softlife-lockup-horizontal-dark.svg";

export function Lockup({ label }: { label?: string }) {
  return (
    <>
      <img className="lockup" src={lockupDark} alt="SoftLife" width={1391} height={540} />
      {label ? <span className="lockup-label">{label}</span> : null}
    </>
  );
}
